var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6262_98311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1061 10.2456H13.9853C13.1876 10.2533 12.4255 10.5802 11.8659 11.1547C11.3063 11.7292 10.995 12.5044 11.0001 13.3105V67.9526C10.9963 68.3526 11.0705 68.7493 11.2185 69.1203C11.3664 69.4913 11.5853 69.8291 11.8625 70.1147C12.1397 70.4002 12.4698 70.6277 12.8341 70.7843C13.1983 70.9409 13.5895 71.0234 13.9853 71.0272H58.089C58.4849 71.0234 58.8761 70.9409 59.2403 70.7843C59.6045 70.6277 59.9347 70.4002 60.2119 70.1147C60.4891 69.8291 60.7079 69.4913 60.8559 69.1203C61.0038 68.7493 61.078 68.3526 61.0742 67.9526V13.3105C61.0794 12.5044 60.768 11.7292 60.2085 11.1547C59.6489 10.5802 58.8867 10.2533 58.089 10.2456H47.1401",
    stroke: "url(#paint0_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4956 6.11997C40.5221 5.94924 40.5381 5.77702 40.5437 5.6043C40.5437 4.39663 40.0689 3.23842 39.2238 2.38447C38.3786 1.53053 37.2323 1.05078 36.0371 1.05078C34.8418 1.05078 33.6955 1.53053 32.8504 2.38447C32.0052 3.23842 31.5304 4.39663 31.5304 5.6043C31.536 5.77702 31.5521 5.94924 31.5785 6.11997H24.0193V15.3924H48.0934V6.11997H40.4956Z",
    stroke: "url(#paint1_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0942 10.2456V71.0272",
    stroke: "url(#paint2_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1533 10.2456V71.0272",
    stroke: "url(#paint3_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4431 58.3395L26.1476 60.1005L29.3831 56.3838",
    stroke: "url(#paint4_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4431 42.8888L26.1476 44.6499L29.3831 40.9331",
    stroke: "url(#paint5_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4431 27.4376L26.1476 29.189L29.3831 25.4819",
    stroke: "url(#paint6_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1252 23.6333H49.326",
    stroke: "url(#paint7_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1252 28.79H45.4549",
    stroke: "url(#paint8_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1252 40.1255H49.326",
    stroke: "url(#paint9_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1252 45.2725H45.4549",
    stroke: "url(#paint10_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1252 55.5762H49.326",
    stroke: "url(#paint11_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1252 60.7231H45.4549",
    stroke: "url(#paint12_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1193 21.5806H21.1016V32.9157H33.1193V21.5806Z",
    stroke: "url(#paint13_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1193 37.0312H21.1016V48.3664H33.1193V37.0312Z",
    stroke: "url(#paint14_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1193 52.4819H21.1016V63.8171H33.1193V52.4819Z",
    stroke: "url(#paint15_linear_6262_98311)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6262_98311",
    x1: 18.1974,
    y1: 12.8568,
    x2: 53.9307,
    y2: 46.3888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6262_98311",
    x1: 27.4795,
    y1: 1.66691,
    x2: 34.4186,
    y2: 14.9346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6262_98311",
    x1: 16.238,
    y1: 12.8568,
    x2: 17.5795,
    y2: 12.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6262_98311",
    x1: 56.2971,
    y1: 12.8568,
    x2: 57.6386,
    y2: 12.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6262_98311",
    x1: 25.1532,
    y1: 56.5435,
    x2: 27.167,
    y2: 59.5922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6262_98311",
    x1: 25.1532,
    y1: 41.0928,
    x2: 27.167,
    y2: 44.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6262_98311",
    x1: 25.1532,
    y1: 25.6412,
    x2: 27.1596,
    y2: 28.6868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6262_98311",
    x1: 38.8789,
    y1: 23.6763,
    x2: 38.9632,
    y2: 24.8484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6262_98311",
    x1: 38.3225,
    y1: 28.833,
    x2: 38.4453,
    y2: 29.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6262_98311",
    x1: 38.8789,
    y1: 40.1684,
    x2: 38.9632,
    y2: 41.3406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6262_98311",
    x1: 38.3225,
    y1: 45.3154,
    x2: 38.4453,
    y2: 46.4806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6262_98311",
    x1: 38.8789,
    y1: 55.6191,
    x2: 38.9632,
    y2: 56.7912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6262_98311",
    x1: 38.3225,
    y1: 60.7661,
    x2: 38.4453,
    y2: 61.9313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6262_98311",
    x1: 22.8289,
    y1: 22.0675,
    x2: 29.3892,
    y2: 29.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6262_98311",
    x1: 22.8289,
    y1: 37.5182,
    x2: 29.3892,
    y2: 45.4407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6262_98311",
    x1: 22.8289,
    y1: 52.9689,
    x2: 29.3892,
    y2: 60.8914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6262_98311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.57abc7a9.svg";
export { ForwardRef as ReactComponent };